<template>
  <v-menu
    transition="slide-y-transition"
    bottom
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-btn flat color="white" v-on="on" :loading="loading" :disabled="loading">
        <span class="font-weight-medium" v-text="selected"></span>
        <v-icon>expand_more</v-icon>
      </v-btn>
    </template>
    <v-expansion-panel
      style="max-width: 340px; background-color: #fff"
      expand
    >
      <v-expansion-panel-content
        v-for="(lang, i) in available"
        :key="i"
        :disabled="loading || lang.name === current"
      >
        <template v-slot:header>
          <h3 class="lang-selector__site-title" @click="onClickLang(lang)">
            <span class="font-weight-medium" v-text="lang.name.toUpperCase()"></span>
          </h3>
          <div @click="onClickLang(lang)">
            <v-progress-circular
              :width="2"
              indeterminate
              size="28"
              v-if="loading"
            ></v-progress-circular>
            <v-tooltip v-else bottom>
              <v-btn v-if="lang.state === 'draft'" slot="activator" small icon color="warning">
                <v-icon small>edit</v-icon>
              </v-btn>
              <v-btn v-if="lang.state === 'published'" slot="activator" small icon color="accent">
                <v-icon small>done</v-icon>
              </v-btn>
              <v-btn v-if="lang.state === 'nonexistent'" slot="activator" small icon color="primary">
                <v-icon small>add</v-icon>
              </v-btn>
              <span v-text="$t(`message.content.language.state.${lang.state}`)"></span>
            </v-tooltip>
          </div>
        </template>
        <v-card>
          <nx-content-selector
            :disabled="loading"
            style="padding: 8px"
            :allow-non-published="true"
            :label="$t('message.block.form.content.search')"
            :type="[contentType]"
            :additional-filters="{siteId: lang.site || siteIdFromLang(lang.name)}"
            :value="selectedContentIdForSite(lang.site || siteIdFromLang(lang.name))"
            @input="updateLangContent(lang, $event)"
          ></nx-content-selector>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-menu>

</template>

<script>
import Storable from '@/mixins/storable';
import api from '@/modules/content/editor/api';
import { mapState } from 'vuex';
import NxContentSelector from '@/modules/content/selector/Selector.vue';
import toast from '@/modules/toast/services';
import DefaultLanguageSelector from '@/modules/content/editor/components/languageSelector/DefaultLanguageSelector.vue';

export default {
  name: 'nx-one-content-one-language-selector',
  extends: DefaultLanguageSelector,
  components: {
    NxContentSelector,
  },
  mixins: [Storable],
  methods: {
    selectedContentIdForSite(site) {
      const selectedData = this.available.find(langData => langData.site === site);
      if (selectedData === undefined) {
        return undefined;
      }

      return selectedData.contentId;
    },
    siteIdFromLang(lang) {
      const media = this.config.sites.available.find((m) => {
        if (m.sites.length === 0) {
          return false;
        }

        return m.sites.find(s => s.languages.find(l => l === lang) !== undefined) !== undefined;
      });
      if (media === undefined) {
        return undefined;
      }

      const site = media.sites.find(s => s.languages.find(l => l === lang) !== undefined);
      if (site === undefined) {
        return undefined;
      }

      return site.id;
    },
    async updateLangContent(lang, data) {
      this.loading = true;

      try {
        if (data) {
          lang = await api.editContentLanguage(this.contentId, lang.name, data.id);
        } else {
          lang = await api.deleteContentLanguage(this.contentId, lang.name);
        }
      } catch (e) {
        console.error(e);
        toast.notify('message.error.langContent', 5000);
        return;
      } finally {
        this.loading = false;
      }

      const availableLanguages = this.available.map((l) => {
        if (l.language) {
          l.name = l.language;
        }

        if (l.name !== lang.language) {
          return l;
        }

        lang.name = lang.language;
        return lang;
      });

      this.$emit('modifyAvailableLanguages', availableLanguages);
    },
  },
  computed: {
    ...mapState(['config']),
    storePath() {
      return this.editorStorePath;
    },
  },
};
</script>
<style lang="stylus" scoped>
.lang-selector__site-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 4ch;
}
</style>
